import {useTwMediaQuery} from "../../../../../../../hooks/useTwMediaQuery";
import {Breakpoint} from "../../../../../../../constants/breakpoint";

export function useImageSize() {
  const isBig = useTwMediaQuery(Breakpoint.SM);
  return isBig ? 88 : 82;
}
